<div class="container">
    <app-folders-list-search-bar [configuration]="configuration" class="folders-list-search-bar"></app-folders-list-search-bar>
    <div class="right-container">
        @if (configuration) {
            <app-folders-list-counter></app-folders-list-counter>
            <app-folders-list-command-bar class="folders-list-command-bar" [view]="view"></app-folders-list-command-bar>
        }
    </div>
</div>
